import React, { useEffect, useState } from 'react';
import { ApiTypes } from '@flashbacktech/flashbackclient/api';
import { Typography } from '@mui/material';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import StorageIcon from '@mui/icons-material/Storage';

interface CommonFieldsProps {
  name: string;
  storageType: ApiTypes.StorageType;
  validationErrors: {
    name?: string;
  };
  isEdit?: boolean;
  onChange: (field: string, value: string) => void;
}

const CommonFields: React.FC<CommonFieldsProps> = ({
  name,
  storageType,
  validationErrors,
  isEdit = false,
  onChange,
}) => {
  const [isOtherProvider, setIsOtherProvider] = useState(false);

  useEffect(() => {
    // Vérifier si le fournisseur sélectionné est "Other"
    const selectedProvider = localStorage.getItem('selectedStorageType');
    setIsOtherProvider(selectedProvider === 'OTHER');
  }, []);

  // Gérer le changement de type de stockage
  const handleStorageTypeChange = (value: string) => {
    onChange('storageType', value);
  };

  return (
    <div className="space-y-5">
      {/* Bucket Label */}
      <div>
        <label className="block text-[13px] font-medium text-[#535862] mb-1.5">
          Bucket Label <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => onChange('name', e.target.value)}
          placeholder="My bucket"
          className={`block w-full rounded-lg border ${
            validationErrors.name ? 'border-red-400 focus:border-red-500 focus:ring-red-500' : 'border-gray-200 focus:border-[#617BFF] focus:ring-[#617BFF]'
          } bg-white px-3.5 py-2.5 text-[14px] text-[#181D27] placeholder-gray-400 focus:ring-1 transition-colors`}
        />
        {validationErrors.name && (
          <p className="mt-1.5 text-[13px] text-red-500">{validationErrors.name}</p>
        )}
      </div>

      {/* Provider field - static text in edit mode */}
      {(isEdit || !isOtherProvider) && (
        <div>
          <label className="block text-[13px] font-medium text-[#535862] mb-1.5">Provider</label>
          <div className="text-[14px] text-[#181D27] py-2 px-3.5 bg-gray-50 rounded-lg border border-gray-100">
            {storageType === ApiTypes.StorageType.BLOB
              ? 'Azure Blob'
              : storageType === ApiTypes.StorageType.S3
              ? 'Amazon S3'
              : storageType === ApiTypes.StorageType.GCS
              ? 'Google Cloud Storage'
              : storageType}
          </div>
        </div>
      )}

      {/* Standard selector - badge style for OTHER providers */}
      {isOtherProvider && !isEdit && (
        <div>
          <label className="block text-[13px] font-medium text-[#535862] mb-2">
            Select your Standard <span className="text-red-500">*</span>
          </label>
          <div className="flex gap-3">
            {[
              { value: ApiTypes.StorageType.S3, label: 'S3' },
              { value: ApiTypes.StorageType.BLOB, label: 'Blob' },
              { value: ApiTypes.StorageType.GCS, label: 'GCS' },
            ].map((option) => (
              <button
                key={option.value}
                type="button"
                onClick={() => handleStorageTypeChange(option.value)}
                className={`px-5 py-2.5 rounded-lg border text-[13px] font-semibold transition-all ${
                  storageType === option.value
                    ? 'border-[#617BFF] bg-[#617BFF]/10 text-[#617BFF]'
                    : 'border-gray-200 bg-white text-gray-500 hover:border-gray-300 hover:bg-gray-50'
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CommonFields;
